"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestEnvironment = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_1 = require("@icr-ui/icons");
const react_1 = require("react");
const general_1 = require("../../general");
const styles_1 = require("./styles");
exports.TestEnvironment = (0, react_1.forwardRef)((props, ref) => {
    const { text, icon } = props;
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledTestEnvironment, { fullWidth: true, alignItems: "center", justifyContent: "center", flexDirection: "row", gap: "8px", ref: ref, "data-testid": "test-environment", children: [icon ? icon : (0, jsx_runtime_1.jsx)(icons_1.EyeShowIcon, { color: "#fff" }), (0, jsx_runtime_1.jsx)(general_1.Typography, { "data-testid": "test-environment-text", variant: "body", size: "tiny", weight: "medium", children: text })] }));
});
exports.TestEnvironment.displayName = 'TestEnvironment';
exports.default = exports.TestEnvironment;
//# sourceMappingURL=test-environment.js.map